import script from "./PlansViewsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./PlansViewsSection.vue?vue&type=script&setup=true&lang=js"

import "./PlansViewsSection.vue?vue&type=style&index=0&id=68a1b3ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68a1b3ea"]])

export default __exports__